export default __webpack_public_path__ + "static/biophilia_shop-8d5bdec7119b322c51ace12e801dd6c0.png";